module.exports = {
  baselink: "https://projectgigs.herokuapp.com"
};
//  http://localhost:9000
//  https://projectgigs.herokuapp.com
